import React from "react";
import GamesNavbar from "../games/components/GamesNavbar";

/**
 * Generic room shell: handles loading/error UI and passes room to children.
 */
export default function GameRoom({ room, loading, error, onRetry, children }) {
  if (loading) {
    return (
      <div className="game-room">
        <GamesNavbar />
        <div className="game-room-content">
          <div className="loading-message">Loading room...</div>
        </div>
      </div>
    );
  }

  if (error || !room) {
    return (
      <div className="game-room">
        <GamesNavbar />
        <div className="game-room-content">
          <div className="error-message">
            <p>{error || "Room not found"}</p>
            {onRetry && (
              <button className="btn-room-action secondary" onClick={onRetry}>
                Retry
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }

  return children(room);
}
